export enum IconSize {
    Default = 'default',
}
